export default "/signup/_next/static/chunks/fonts/CircularStd-Medium-d19dcc38a149cb85c5d85eb28486992c.otf";